import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SectionHeading, Reveal } from "@/components/Primitives";
import { Search, Monitor, FileText, Code2, Eye, Rocket, HandshakeIcon, Handshake } from "lucide-react";

const STEPS = [
  { icon: Search, t: "Discovery", d: "We learn about your business, goals and the customers you want to reach." },
  { icon: Monitor, t: "Demo", d: "We create a free demo so you can see the direction before committing." },
  { icon: FileText, t: "Proposal", d: "A clear proposal with scope, timeline, package and transparent costs." },
  { icon: Code2, t: "Development", d: "We build your website with your content, brand and features." },
  { icon: Eye, t: "Review", d: "You review on a staging link and request revisions within your allowance." },
  { icon: Rocket, t: "Launch", d: "We connect your domain and hosting and take your site live." },
  { icon: Handshake, t: "Handover", d: "Training, source files and a handover checklist so you're in control." },
];

export default function Process() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <SectionHeading eyebrow="Our Process" title="A clear path from idea to launch"
        subtitle="Seven honest steps. You always know what's happening and what comes next." />
      <div className="relative max-w-3xl mx-auto">
        <div className="absolute left-[27px] top-2 bottom-2 w-px bg-gradient-to-b from-violet-500/60 via-cyan-500/40 to-transparent hidden sm:block" />
        <div className="space-y-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.06}>
              <div className="flex gap-5 items-start">
                <span className="relative z-10 grid place-items-center w-14 h-14 rounded-2xl glass-strong text-violet-300 shrink-0"><s.icon className="w-6 h-6" /></span>
                <div className="glass rounded-2xl p-5 flex-1 card-hover">
                  <div className="flex items-center gap-2 mb-1"><span className="font-mono text-xs text-cyan-300">Step {i + 1}</span><h3 className="font-semibold text-white">{s.t}</h3></div>
                  <p className="text-sm text-slate-400 leading-relaxed">{s.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
      <div className="text-center mt-12"><Link to="/contact"><Button className="bg-violet-600 hover:bg-violet-500 text-white font-semibold">Start with a Free Demo</Button></Link></div>
    </div>
  );
}
